import type { Project } from '@thom/folio-domain/core/domain/project'
import type { Live } from '@thom/folio-domain/core/ports/live'
import type { ProjectFilter } from '@thom/folio-domain/core/ports/projects'
import { Collections } from '@thom/folio-ui/pocketbase-types'
import { columns, toProject } from './projects-adapter'
import type { Realtime } from './realtime'

const MAX_ROWS = 500

const createProjectsLive = ({ client, connection }: Realtime): Live<Project, ProjectFilter> => ({
	source: { client, collection: Collections.JournProjects, map: toProject, connection },
	options: filter => ({ filter: columns(filter), sort: 'name', perPage: filter.limit ?? MAX_ROWS }),
})

export { createProjectsLive }
